import config from "../../../config";

export const getBalanceChecker = async (balanceCheckerId) => {
  const response = await fetch(
    `${config.cardbase.url}/balanceChecker/${balanceCheckerId}`,
    { method: "GET" },
  );
  const responseBody = await response.json();

  if (response.status !== 200 && responseBody) {
    throw responseBody;
  }

  return responseBody;
};

export const getCardPin = async (balanceCheckerId, cardNumber, pinCode) => {
  const response = await fetch(
    `${config.cardbase.url}/balanceChecker/${balanceCheckerId}/cardNumber/${cardNumber}/pinCode/${pinCode}`,
    { method: "GET" },
  );
  const responseBody = await response.json();

  if (response.status !== 200) {
    throw responseBody;
  }

  return responseBody;
};

export const getCardCaptcha = async (
  balanceCheckerId,
  cardNumber,
  captchaToken,
) => {
  const response = await fetch(
    `${config.cardbase.url}/balanceChecker/${balanceCheckerId}/cardNumber/${cardNumber}/captcha`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: captchaToken }),
    },
  );
  const responseBody = await response.json();

  if (response.status !== 200) {
    throw responseBody;
  }

  return responseBody;
};

export const getCard = async (balanceCheckerId, cardNumber) => {
  const response = await fetch(
    `${config.cardbase.url}/balanceChecker/${balanceCheckerId}/cardNumber/${cardNumber}`,
    { method: "GET" },
  );
  const responseBody = await response.json();

  if (response.status !== 200) {
    throw responseBody;
  }

  return responseBody;
};
